export default {
  loading: false,
  errors: [],
  data: [],
}
